import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"
import { RouterProvider } from "react-router-dom"
import { ToastContainer } from "react-toastify"

import "react-toastify/dist/ReactToastify.css"

import { AppContextProvider } from "@contexts/app_context"
import router from "@navigations/router"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import theme from "./constants/theme"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContextProvider>
          <RouterProvider router={router} />
        </AppContextProvider>
        <ToastContainer />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
